// extracted by mini-css-extract-plugin
module.exports = {"root":"ChangeOwnershipModal_root__3e7LS","ownerData":"ChangeOwnershipModal_ownerData__2gkBI","value":"ChangeOwnershipModal_value__2F6fM"};